import React from 'react';
export function HeroSection() {
  return <section className="py-16 md:py-24 px-6 max-w-3xl mx-auto text-center" data-id="element-18">
      <div className="inline-block mb-6 px-4 py-1.5 rounded-full bg-[#C5A55A]/15 text-[#C5A55A] text-sm font-bold tracking-wider uppercase border border-[#C5A55A]/20" data-id="element-19">
        Para artistas de cejas frustradas
      </div>

      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-[#F5F0EB] mb-8" data-id="element-20">
        ¿Te compraste todo el kit, hiciste el curso caro... y ahora el equipo
        está guardado en un cajón por miedo?
      </h1>

      <div className="w-24 h-1 bg-[#C5A55A] mx-auto mb-8 rounded-full opacity-60" data-id="element-21"></div>

      <p className="text-xl md:text-2xl text-[#A89B8C] leading-relaxed font-light" data-id="element-22">
        Lo entiendo perfectamente. Te dijeron que sería fácil. Pagaste una
        fortuna por una certificación que hoy cuelga en tu pared, pero cada vez
        que una amiga te pide que le hagas las cejas, inventas una excusa.
      </p>
    </section>;
}